import { ProductRow } from '../types';
import { GiftCard, ProductType } from '@/api/Cart/cart.interfaces';
import { Money } from '@libs/money/money.interfaces';
import { t } from '@shared/helpers/translation';
import store from '@/store';

export const getAmountAlreadyPaid = (): ProductRow[] => {
    const paid: Money = store.getters['cart/getAmountAlreadyPaidAmount'];
    return paid && paid.Amount > 0
        ? [
              {
                  type: ProductType.Other,
                  items: [
                      {
                          price: paid,
                          priceIsNegative: true,
                          label: t({ key: 'shared.sum_already_payed' }),
                      },
                  ],
              },
          ]
        : [];
};

export const getDiscountCode = (isWhiteLabel: boolean): ProductRow[] => {
    const discount: Money = store.getters['cart/getCampaignDiscountAmount'];

    return discount && discount.Amount > 0
        ? [
              {
                  type: ProductType.Other,
                  items: [
                      {
                          price: discount,
                          priceIsNegative: true,
                          label: isWhiteLabel
                              ? t({ key: 'shared.discount_through_partner' })
                              : t({ key: 'shared.discount_code' }),
                      },
                  ],
              },
          ]
        : [];
};

export const getGiftCards = (): ProductRow[] => {
    const cards: GiftCard[] = store.getters['cart/getGiftCards'];

    return cards?.length > 0
        ? cards.map((card) => {
              return {
                  type: ProductType.Giftcard,
                  items: [
                      {
                          price: card.Value,
                          priceIsNegative: true,
                          label: `${t({ key: 'shared.gift_card', suffix: card.Code && ':' })} ${card.Code ?? ''}`,
                      },
                  ],
              };
          })
        : [];
};

export const getAgencyCommision = (): ProductRow[] => {
    const commission = store.getters['cart/getAgencyCommisionAmount'];
    return commission?.Amount > 0
        ? [
              {
                  type: ProductType.Other,
                  items: [
                      {
                          price: commission,
                          priceIsNegative: true,
                          label: t({ key: 'shared.commission' }),
                      },
                  ],
              },
          ]
        : [];
};

export const getPaymentDiscountMethod = (): ProductRow[] => {
    const method = store.getters['cart/getPaymentMethodDiscount'];
    const applies = store.getters['cart/paymentMethodDiscountApplies'];
    const label = store.getters['cart/getPaymentMethodDiscountLabel'];

    return method && method.Amount > 0
        ? [
              {
                  type: ProductType.Other,
                  items: [
                      {
                          price: method,
                          priceIsNegative: true,
                          disabled: !applies,
                          label: `${t({
                              key: 'shared.discount_when_paying_with',
                          })} ${label}`,
                      },
                  ],
              },
          ]
        : [];
};
